export enum CONTACT_ISSUE_CHANNEL {
  TEXT = 'text',
  EMAIL = 'email',
}

export enum CONTACT_ISSUE_REASON_CODE {
  PLIVO_50 = 'plivo_50',
  PLIVO_100 = 'plivo_100',
  PLIVO_200 = 'plivo_200',
  EMAIL_BOUNCE = 'email_bounce',
  EMAIL_COMPLAINT_SUPPRESSED = 'email_complaint_suppressed',
}

export type ContactIssue = {
  id: string;
  channel: CONTACT_ISSUE_CHANNEL;
  reasonCode: string;
  consecutiveCount: number | null;
};

export type MemberContactIssues = {
  hasContactIssue?: boolean;
  contactIssues?: ContactIssue[];
};
